import React from "react"

const PasswordVisibilityToggle = ({ visible, onToggle, className = "" }) => (
  <button
    type="button"
    onClick={onToggle}
    className={`absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-800 ${className}`}
    aria-label={visible ? "Hide password" : "Show password"}
  >
    {visible ? (
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.03-10-7 0-.87.255-1.69.7-2.435m3.364-2.95C7.502 6.208 9.675 5 12 5c5.523 0 10 4.03 10 7 0 .87-.255 1.69-.7 2.435m-3.364 2.95A10.05 10.05 0 0112 19c-1.415 0-2.755-.283-3.975-.8"
        />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4l16 16" />
      </svg>
    ) : (
      <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
        />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    )}
  </button>
)

export default PasswordVisibilityToggle
